import React, { useState } from 'react';
import axios from 'axios';
// --- 1. IMPORT useLocation ---
import { useNavigate, useLocation } from 'react-router-dom';
import loginImage from '../../assets/login-img/welcome-back.svg';
import './Login.css';
import { useNotification } from '../../context/NotificationContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  // --- 2. CALL useLocation ---
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);

  const { showNotification } = useNotification();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/api/v1/token/login/', {
        email,
        password,
      });
      localStorage.setItem('authToken', res.data.auth_token);
      showNotification('Login successful!');

      const fromPage = location.state?.from?.pathname || '/';

      navigate(fromPage, { replace: true });

    } catch (err) {
      showNotification(
        'Login failed: ' + (err.response?.data?.non_field_errors?.[0] || err.message),
        'error'
      );
    }
  };

  return (
    <div className='login-wrapper'>
      <div className='login-card'>
        <div className='login-image-section'>
          <img src={loginImage} alt="Login" />
        </div>
        <div className='login-form-section'>
          <form onSubmit={handleSubmit}>
            <input
              type='text'
              placeholder='Email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder='Password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button className='show-password'
              type='button'
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? 'Hide Password' : 'Show Password'}
            </button>

            <div className='button-row'>
              <button className='lr-loggin' type='submit'>Log In</button>
              <a className='lr-loggin' href='/register'>Register</a>
            </div>

          </form>

          <div className='links'>
            <a href='/reset-password'>I have forgotten my password</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
